module.exports = __webpack_public_path__ + "img/Connect everything.58fa582a.png";